import { API_BASE_URL } from "../../config/siteConfig";

let serverPath = (path = "") => {
  try {
    return new URL(path || "/", `${API_BASE_URL}/`).href
  } catch (error) {
    return API_BASE_URL
  }
};

export default serverPath;